import { useState } from 'react';
import EmbeddedYouTubeVideoThumbnail from '@Components/Shared/EmbeddedYouTubeVideoThumbnail';
import translator from '@Components/Utilities/Translator';
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';


const Accordion = styled((props) => (
    <MuiAccordion disableGutters {...props} />
))(({ theme }) => ({
    boxShadow: 'none',
    '&:before': {
        display: 'none',
    },
}));


const FAQAccordion = (props) => {

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);

        //Fixes scroll issues with accordion. 
        let expPanel = document.getElementById(panel + "a-header")       
        setTimeout(function () {
            let y = expPanel.getBoundingClientRect().top + window.scrollY - 10;

            let visibleWindow = window.scrollY
            let visibleBottom = visibleWindow + window.innerHeight

            if (y < visibleWindow || y > visibleBottom) {
                window.scrollTo({ top: y, behavior: "smooth" })
            }

        }, 450)

    };

    const displayAnswer = (question, answer) => {
        return (
            <>
                <div dangerouslySetInnerHTML={{ __html: answer[0] }} />
                {question === translator.translate('sandhills.faq.ef.canireceivealerts') && props.YouTubeBidCallerAccountSettingsAndAlertsVideoID &&
                    <div className="youtube-thumbnail-container">
                        <EmbeddedYouTubeVideoThumbnail
                            descriptionText={translator.translate('sandhills.faq.ef.canireceivealerts')}
                            altText={translator.translate('sandhills.faq.ef.canireceivealerts')}
                            videoId={props.YouTubeBidCallerAccountSettingsAndAlertsVideoID}
                            onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "FAQAccordion_AccountSettingsAndAlerts")}
                        />
                    </div>
                }
                {question === translator.translate('sandhills.faq.ef.howdoiuseefsite') && props.YouTubeBidCallerNavigationVideoID &&
                    <div className="youtube-thumbnail-container">
                        <EmbeddedYouTubeVideoThumbnail
                            descriptionText={translator.translate('sandhills.faq.ef.howdoiuseefsite') }
                            altText={translator.translate('sandhills.faq.ef.howdoiuseefsite')}
                            videoId={props.YouTubeBidCallerNavigationVideoID}
                            onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "FAQAccordion_EFNavigation")}
                        />
                    </div>
                }
            </>
        );
    };
    
    return (
        <div className='faq-container'>
            {Object.entries(props.FAQTranslations).map(([question, answer], i) => (
                <Accordion expanded={expanded === 'panel' + i} onChange={handleChange('panel' + i)} className='faq-accordion'>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon fontSize ='large' />}
                        aria-controls={"panel" + i + "a-content"}
                        id={"panel" + i + "a-header"}
                        className='faq-summary'
                    >
                        <h2>{question}</h2>
                    </AccordionSummary>
                    <AccordionDetails className='faq-details'>
                        {displayAnswer(question, answer)}
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    );
};

export default FAQAccordion;